<app-breadcrumb *ngIf="!meeting && !dialogRefFront && name==='Egzaminy' " [master]="'Rejestracje'" [parentName]="'Egzaminy'" [name]="'Dodaj'"></app-breadcrumb>
<app-breadcrumb *ngIf="!meeting && !dialogRefFront && name==='Szkolenia'" [master]="'Rejestracje'" [parentName]="'Szkolenia'" [name]="'Dodaj'"></app-breadcrumb>
<div class="meeting-add" fxLayout="column" fxLayoutGap="15px"  >
  <div class="status-info" *ngIf="meeting && statusEdit">
    <app-dict
      [label]="'Status'" [dictType]="'meeting_status'"
      [control]="statusControl"
      [required]="true"
      [multiple]="false"
      appearance="fill"
      [color]="true"
    ></app-dict>
  </div>
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" *ngIf=" !dialogRefFront ">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!meetingFormValid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div [fxFlex]="addressGroup.enabled && !dialogRefFront ? '50' : '100'" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>
        <div fxLayout="row">
          <h3>Dane</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <app-dict [fxFlex]="currentType?.key === MEETING_TYPE_NEW_AGENT_TRAINING ||
           currentType?.key === MEETING_TYPE_IDD_TRAINING ? '50' : '100'" dictType="meeting_type" label="Rodzaj"
                    [required]="true" [onlyKeys]="typeOnlyKeys" [control]="typeControl"  (selectedDict)="typeChanged($event)"></app-dict>

          <app-dict *ngIf="currentType?.key === MEETING_TYPE_NEW_AGENT_TRAINING" fxFlex="50" dictType="meeting_leader" label="Organizator"
                    [onlyKeys]="MEETING_TYPES"
                    [required]="true" [control]="leaderControl"
                    (selectedDict)="leaderChanged($event)"></app-dict>
          <app-dict *ngIf="currentType?.key === MEETING_TYPE_IDD_TRAINING" fxFlex="50" dictType="meeting_leader" label="Organizator"
                    [required]="true" [control]="leaderControl"
                    (selectedDict)="leaderChanged($event)"></app-dict>
        </div>


        <div fxLayout="row" *ngIf="iddTrainingTrainerControl.enabled">
          <app-dict-idd-training-trainer fxFlex="100" label="Prowadzący szkolenie" [required]="true"
                                         [control]="iddTrainingTrainerControl"
          ></app-dict-idd-training-trainer>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <app-dict [fxFlex]="insuranceCompanyControl.enabled ? '50' : '100'" dictType="meeting_place" label="Typ"
                    [required]="true" [control]="placeControl" (selectedDict)="placeChanged($event)"></app-dict>

          <app-dict-insurance-companies *ngIf="insuranceCompanyControl.enabled" fxFlex="50" label="TU" [required]="true"
                                        [control]="insuranceCompanyControl" [hideChildren]="true"></app-dict-insurance-companies>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign=" center" *ngIf="stationary && currentType?.key !== MEETING_TYPE_EXAM && currentType?.key !== MEETING_TYPE_ENTRANCE_EXAM">
          <div fxFlex="30">
          <mat-slide-toggle [formControl]="centralControl" color="accent">Centrala ASF</mat-slide-toggle>
          </div>
          <div fxFlex="30">
            <mat-slide-toggle [formControl]="pgeControl" color="accent">Loża PGE</mat-slide-toggle>
          </div>

          <div fxFlex="70" *ngIf="centralControl.value ">
            <app-dict *ngIf="centralControl.value "  dictType="room" label="Sala"
                      [skipKeys]=[ROOM_PGE]
                      [sortDESC]="true" [required]="true" [control]="roomControl"></app-dict>
          </div>
        </div>

        <div fxLayout="row" >
          <div fxFlex="100" *ngIf="subjectControl.enabled">
            <mat-form-field fxFlex="100">
              <mat-label>Temat</mat-label>
              <input [required]="true" matInput placeholder="Temat" [formControl]="subjectControl">
              <mat-error *ngIf="meetingForm.get('subject').hasError('required')">To pole jest wymagane</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" >
          <div fxFlex="100" *ngIf="currentType?.key !== MEETING_TYPE_IDD_TRAINING &&
           currentType?.key !== MEETING_TYPE_EXAM && currentType?.key !== MEETING_TYPE_ENTRANCE_EXAM && currentType?.key !== MEETING_TYPE_NEW_AGENT_TRAINING">
            <mat-form-field fxFlex="100">
              <mat-label>Prowadzący</mat-label>
              <input [required]="true" matInput placeholder="Prowadzący" [formControl]="meetingLeadingControl">
              <mat-error *ngIf="meetingForm.get('meetingLeading').hasError('required')">To pole jest wymagane</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" *ngIf="currentType?.key === MEETING_TYPE_IDD_TRAINING">
          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Liczba minut - majątek</mat-label>
              <input [required]="false" type="number" matInput placeholder="Liczba minut - majątek" [formControl]="minutesAssetsControl">
              <mat-error *ngIf="meetingForm.get('minutesAssets').hasError('required')">To pole jest wymagane</mat-error>
            </mat-form-field>
          </div>

          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Liczba minut - życie</mat-label>
              <input [required]="false" type="number" matInput placeholder="Liczba minut - życie" [formControl]="minutesLifeControl">
              <mat-error *ngIf="meetingForm.get('minutesLife').hasError('required')">To pole jest wymagane</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" *ngIf="examTypeControl.enabled">
          <app-dict fxFlex="100" dictType="meeting_exam_type" label="Rodzaj egzaminu"
                    [required]="true" [control]="examTypeControl" ></app-dict>
        </div>

        <div fxLayout="row" fxLayoutGap="15px"  *ngIf="thematicScopeValid" >
          <div fxFlex="33">
            <app-datepicker
              label="Data rozpoczecia"
              placeholder="2000-01-01 00:00"
              [required]="true"
              [control]="startsAtControl"
            ></app-datepicker>
          </div>

          <div fxFlex="175px">
            <div>
              <ngx-timepicker-field [format]="24" [defaultTime]="'12:00'" [formControl]="startsAtTimeControl"></ngx-timepicker-field>
            </div>
          </div>

          <div fxFlex="50">
            <div>
              <mat-form-field style="width: 100%" >
                <mat-label>Czas trwania</mat-label>
                <mat-select [formControl]="meetingTimeControl">
                  <mat-option [value]="30">30 minut</mat-option>
                  <mat-option [value]="60">1 godz.</mat-option>
                  <mat-option [value]="90">1 godz. 30 min.</mat-option>
                  <mat-option [value]="120">2 godz.</mat-option>
                  <mat-option [value]="180">3 godz.</mat-option>
                  <mat-option [value]="240">4 godz.</mat-option>
                  <mat-option [value]="300">5 godz.</mat-option>
                  <mat-option [value]="360">6 godz.</mat-option>
                  <mat-option [value]="420">7 godz.</mat-option>
                  <mat-option [value]="480">8 godz.</mat-option>
                  <mat-option *ngIf="null !== meetingMinutesSelected" [value]="meetingMinutesSelected">{{meetingMinutesSelected}} min.</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

        </div>

        <div fxLayout="row" fxLayoutGap="15px"  *ngIf="thematicScopeValid" >
          <div fxFlex="33">
            <app-datepicker
              label="Data zakończenia"
              placeholder="2000-01-01 00:00"
              [required]="true"
              [control]="endsAtControl"
            ></app-datepicker>
          </div>

          <div fxFlex="175px">
            <div>
              <ngx-timepicker-field [format]="24" [defaultTime]="'13:00'" [formControl]="endsAtTimeControl"></ngx-timepicker-field>
            </div>
          </div>

          <span fxFlex="50"></span>
        </div>


        <div fxLayout="row" *ngIf="linkControl.enabled">
          <div fxFlex="100">
            <mat-form-field fxFlex="100">
              <mat-label>Link</mat-label>
              <input [required]="true" matInput placeholder="Link" [formControl]="linkControl">
              <mat-error *ngIf="meetingForm.get('link').hasError('required')">To pole jest wymagane</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" *ngIf="!newTypeTraining">
          <div fxFlex="33">
            <app-datepicker
              label="Do kiedy można zapisywać"
              placeholder="2000-01-01 00:00"
              [required]="true"
              [control]="registrationsToControl"
            ></app-datepicker>
          </div>

          <div fxFlex="175px">
            <div>
              <ngx-timepicker-field [format]="24" [defaultTime]="'12:00'" [formControl]="registrationsToTimeControl"></ngx-timepicker-field>
            </div>
          </div>

          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Limit osób</mat-label>
              <input [required]="false" type="number" matInput placeholder="Limit osób" [formControl]="limitOfPeopleControl">
              <mat-error *ngIf="meetingForm.get('limitOfPeople').hasError('required')">To pole jest wymagane</mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" fxLayoutGap="15px"  *ngIf="newTypeTraining">
          <div fxFlex="50">
            <mat-form-field fxFlex="100">
              <mat-label>Limit osób</mat-label>
              <input [required]="false" type="number" matInput placeholder="Limit osób" [formControl]="limitOfPeopleControl">
              <mat-error *ngIf="meetingForm.get('limitOfPeople').hasError('required')">To pole jest wymagane</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px" *ngIf="stationary  && currentType?.key !== MEETING_TYPE_EXAM && currentType?.key !== MEETING_TYPE_ENTRANCE_EXAM" fxLayoutAlign="space-between center">
          <div fxFlex="50">
            <mat-slide-toggle [formControl]="accommodationControl" color="accent"> Nocleg</mat-slide-toggle>
          </div>

          <div fxFlex="50">
            <mat-slide-toggle [formControl]="mealControl" color="accent">Posiłek</mat-slide-toggle>
          </div>


        </div>

        <div fxLayout="row" fxLayoutGap="15px" *ngIf="stationary" fxLayoutAlign="space-between center">
          <div fxFlex="50" >
            <mat-form-field fxFlex="100"  *ngIf="accommodationControl.value">
              <mat-label>Szczegóły</mat-label>
              <input [required]="false" matInput placeholder="Szczegóły" [formControl]="accommodationDetailControl">
            </mat-form-field>
          </div>

          <div fxFlex="50" >
            <mat-form-field fxFlex="100" *ngIf="mealControl.value">
              <mat-label>Szczegóły</mat-label>
              <input [required]="false" matInput placeholder="Szczegóły" [formControl]="mealDetailControl">
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row"  *ngIf="currentType?.key !== MEETING_TYPE_IDD_TRAINING &&
           currentType?.key !== MEETING_TYPE_EXAM && currentType?.key !== MEETING_TYPE_ENTRANCE_EXAM && currentType?.key !== MEETING_TYPE_NEW_AGENT_TRAINING">
          <h4>Agenda</h4>
        </div>

        <div fxLayout="row"  fxLayoutAlign="center"  *ngIf="currentType?.key !== MEETING_TYPE_IDD_TRAINING &&
           currentType?.key !== MEETING_TYPE_EXAM && currentType?.key !== MEETING_TYPE_ENTRANCE_EXAM && currentType?.key !== MEETING_TYPE_NEW_AGENT_TRAINING">

          <app-file-drag-and-drop fxFlex="100"  [multiple]="false"  acceptMime="*/*"  [fileControl]="fileControl"></app-file-drag-and-drop>
        </div>

      </mat-card>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" fxLayout="column" *ngIf="addressGroup.enabled && !dialogRefFront" >

      <app-address-form fxFlex="100" title="Adres" [addressForm]="addressGroup" [simple]="true" [required]="true"></app-address-form>



    </div>

  </div>
  <div  fxLayout="row" fxFlex.lt-md="100%" *ngIf="addressGroup.enabled && dialogRefFront ">
    <div [fxFlex]="100">

      <app-address-form fxFlex="100" title="Adres" [addressForm]="addressGroup" [simple]="true" [required]="true"></app-address-form>

    </div>

  </div>
  <div  fxLayout="row" fxFlex.lt-md="100%" *ngIf="!thematicScopeValid">
    <div [fxFlex]="addressGroup.enabled && !dialogRefFront ? '50' : '100'">
      <mat-card class="partners-add-card" fxLayout="column">
        <div fxLayout="row">
          <h3>
            Zakres tematyczny szkolenia
          </h3>
        </div>

        <div fxLayout="column" fxFlex="100" *ngFor="let formGroup of thematicScopeFormArray; index as i">
          <div fxLayout="row" fxLayoutGap="15px" [formGroup]="formGroup">

            <div fxFlex="100" fxLayoutGap="10px">
              <div fxFlex="30" >
                <app-datepicker
                  label="Data rozpoczecia"
                  placeholder="2000-01-01 00:00"
                  [required]="true"
                  formControlName="thematicScopeStartsAt"
                ></app-datepicker>

              </div>
              <div fxFlex="25">
                <div>
                  <ngx-timepicker-field [format]="24" [defaultTime]="'12:00'"   formControlName="thematicScopeStartsAtTime"></ngx-timepicker-field>
                </div>
              </div>

              <div fxFlex="30" fxLayoutGap="10px">
                <div fxFlex="100" >
                  <mat-form-field style="width: 100%" >
                    <mat-label>Czas trwania</mat-label>
                    <mat-select  formControlName="thematicScopeMinutesTotal">
                      <mat-option [value]="30">30 minut</mat-option>
                      <mat-option [value]="60">1 godz.</mat-option>
                      <mat-option [value]="90">1 godz. 30 min.</mat-option>
                      <mat-option [value]="120">2 godz.</mat-option>
                      <mat-option [value]="180">3 godz.</mat-option>
                      <mat-option [value]="240">4 godz.</mat-option>
                      <mat-option [value]="300">5 godz.</mat-option>
                      <mat-option [value]="360">6 godz.</mat-option>
                      <mat-option [value]="420">7 godz.</mat-option>
                      <mat-option [value]="480">8 godz.</mat-option>
                      <mat-option *ngIf="null !== meetingMinutesSelected" [value]="meetingMinutesSelected">{{meetingMinutesSelected}} min.</mat-option>
                    </mat-select>
                  </mat-form-field>

                </div>


              </div>

            </div>

          </div>

          <div fxLayout="row" fxLayoutGap="15px" [formGroup]="formGroup">



            <div fxFlex="100" fxLayoutGap="10px">
              <div fxFlex="32" >
                <app-datepicker
                  label="Data zakończenia"
                  placeholder="2000-01-01 00:00"
                  [required]="true"
                  formControlName="thematicScopeEndsAt"
                ></app-datepicker>

              </div>
              <div fxFlex="27">
                <div>
                  <ngx-timepicker-field [format]="24" [defaultTime]="'12:00'"   formControlName="thematicScopeEndsAtTime"></ngx-timepicker-field>
                </div>
              </div>

            </div>

            <div fxFlex="5"  fxLayoutGap="15px">
              <div class="list-remove-button">
                <button (click)="removeThematicScope(i)" mat-icon-button color="warn">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>

          </div>

          <div fxLayout="row" fxLayoutGap="15px" [formGroup]="formGroup">

            <div fxFlex="98" fxLayoutGap="10px">
              <div fxFlex="88" >
                <mat-form-field fxFlex="100">
                  <mat-label>Temat</mat-label>
                  <input appCapitalizeFirst matInput placeholder="Temat" formControlName="thematicScopeSubject">
                </mat-form-field>
              </div>

            </div>

          </div>

        </div>

        <div fxFlex="100" fxLayout="row">
              <span fxFlex="">
                  <mat-error *ngIf="meetingForm.get('thematicScope').hasError('minLength')">Musisz podać przynajmniej jeden zakres tematyczny szkolenia.</mat-error>
              </span>
          <button (click)="addThematicScope()" mat-stroked-button color="primary">
            <mat-icon>add_box</mat-icon> <span> Dodaj</span>
          </button>
        </div>
      </mat-card>

    </div>

  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="save()" [class.spinner]="processingRequest"
            [disabled]="!meetingFormValid || processingRequest"
            mat-stroked-button color="primary"><mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>
